module.exports = "/images/flag-en.svg?3f6935215b1dec51b610543af3bd9880";